import { EntityTemplateRowViewModel, TemplateEntityType } from "../EntityTemplate.types.ts";
import { useChangeEntityTemplateActiveStatusDialog } from "./ChangeEntityTemplateActiveStatusDialog.hooks.ts";
import { Trans } from "react-i18next";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../localization/useTranslation.ts";

export interface ChangeEntityTemplateActiveStatusDialogProps {
    entityTemplate: EntityTemplateRowViewModel;
    templateEntityType: TemplateEntityType;
    onCloseDialog: () => void;
    onToggledActiveStatus: () => void;
}

function ChangeEntityTemplateActiveStatusDialog(props: ChangeEntityTemplateActiveStatusDialogProps) {
    const { translateString } = useTranslation();
    const { inProgress, onToggleActiveStatus, infoTranslationKey } = useChangeEntityTemplateActiveStatusDialog(props);

    const header = (props.entityTemplate.active ? translateString("deactivate") : translateString("activate")) + " " + props.entityTemplate.name;

    return (
        <DotLegalInfoDialog
            btnText={props.entityTemplate.active ? translateString("deactivate") : translateString("activate")}
            header={header}
            inProgress={inProgress}
            content={<Trans i18nKey={infoTranslationKey} values={{ name: props.entityTemplate.name }}></Trans>}
            onBtnClick={() => onToggleActiveStatus()}
            onCloseDialog={props.onCloseDialog}
        />
    );
}

export default ChangeEntityTemplateActiveStatusDialog;
